var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { createStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import en from './i18n/en.json';
import it from './i18n/it.json';
import es from './i18n/es.json';
import pt from './i18n/pt.json';
import useRegisteredTranslation from '@dev-togetherprice/hooks.use-register-translation';
import SearchIcon from '@dev-togetherprice/icons.search';
const TRANSLATIONS = { en, es, it, pt };
const useStyles = makeStyles((theme) => createStyles({
    root: {
        padding: 0,
        '&, .MuiTextField-root, .MuiInputBase-input': {
            color: theme.palette.primary.main,
            '& fieldset': {
                border: 0,
            },
        },
        backgroundColor: ({ desktop }) => desktop ? '#F6F8FA' : theme.palette.common.white,
        borderRadius: ({ desktop }) => (desktop ? '12px' : '45px'),
        borderColor: theme.palette.common.white,
        height: '50px',
    },
    icon: {
        color: theme.palette.common.white,
        paddingRight: theme.spacing(1),
        fontSize: '24px',
    },
}));
export const defaultSearchProps = {
    onFocus: () => localStorage.setItem('isFocused', 'true'),
    onBlur: () => localStorage.setItem('isFocused', 'false'),
    autoFocus: localStorage.getItem('isFocused') === 'true',
};
const SearchField = (_a) => {
    var { desktop } = _a, props = __rest(_a, ["desktop"]);
    const classes = useStyles({ desktop });
    const { t } = useRegisteredTranslation('SearchField', TRANSLATIONS);
    return (React.createElement(TextField, Object.assign({ fullWidth: true, className: classes.root, variant: 'outlined', placeholder: t('search-field-default-placeholder'), InputProps: {
            className: classes.root,
            startAdornment: (React.createElement(InputAdornment, { position: 'end' },
                React.createElement(SearchIcon, { className: classes.icon }))),
        } }, props)));
};
export default SearchField;
